import React from 'react';
import classes from './classes.module.scss';
import Const from '../../../config/const';

function NetworkStateComponent({ state, t }) {
  const renderNetworkState = () => <div>{ t('chat.network_seems_to_be_offline') }</div>;

  return state !== Const.pubnub.states.down ? null : (
    <div className={ classes.container }>
      <div className={ classes.holder }>
        {renderNetworkState()}
      </div>
    </div>
  );
}

export default NetworkStateComponent;
